import { render, staticRenderFns } from "./StatisticsOld.vue?vue&type=template&id=6258c16f&"
import script from "./StatisticsOld.vue?vue&type=script&lang=js&"
export * from "./StatisticsOld.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports